<template>
  <v-autocomplete
    @input="event => { emitChange(event) }"
    v-model="selectedTag"
    :items="loadedTags"
    :label="labelText"
    clearable
    dense
    outlined
  ></v-autocomplete>
</template>

<script>
import VideoService from "@/services/VideoService";

export default {
  data() {
    return {
      selectedTag: null,
      loadedTags: null,
      labelText: null,
      academyOnly: { type: Boolean, default: false }
    }
  },
  created() {
    if(this.label)
      this.labelText = this.label;
    VideoService.tags(this.academyOnly)
      .then(data => {
        if (data) this.loadedTags = data;
      });
  },
  props: {
    value: null,
    label: null
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedTag = newValue;
      }
    }
  },
  methods: {
    emitChange (event) {
      this.$emit('input', event)
    }
  }
};
</script>

<style scoped>
</style>
